import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
} from "@getgreenline/blaze-ui";
import { PanelLeft, ChevronRight } from "lucide-react";
import { UserMenu } from "./user-menu";
import { type ThemeMode } from "../../hooks/use-theme";
import { useAuthStore } from "../../stores/auth-store";
import { getInitials } from "@/utils/strings";

type CampaignNavigationProps = {
  currentPageLabel: string;
  currentStepLabel?: string;
  onToggleSidebar: () => void;
  onLogout: () => void;
  theme: ThemeMode;
  onThemeChange: (theme: ThemeMode) => void;
};

export function TopNavigation({
  currentPageLabel,
  currentStepLabel,
  onToggleSidebar,
  onLogout,
  theme,
  onThemeChange,
}: CampaignNavigationProps) {
  const user = useAuthStore((s) => s.user);
  const realm = useAuthStore((s) => s.realm);
  return (
    <header className="tw:sticky tw:top-0 tw:z-20 tw:border-b tw:bg-background/95 tw:backdrop-blur">
      <div className="tw:flex tw:min-h-12 tw:items-center tw:justify-between tw:gap-4 tw:px-3 sm:tw:px-8">
        <div className="tw:flex tw:min-w-0 tw:items-center tw:gap-3">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={onToggleSidebar}
            className="tw:h-9 tw:w-9 tw:cursor-pointer tw:rounded-lg tw:hover:bg-accent! tw:hover:text-sky-500!"
          >
            <PanelLeft className="tw:h-4 tw:w-4" />
          </Button>

          <Breadcrumb className="tw:min-w-0">
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage className="tw:text-sm tw:font-normal tw:text-muted-foreground">
                  Blaze ads
                </BreadcrumbPage>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="tw:text-muted-foreground">
                <ChevronRight />
              </BreadcrumbSeparator>
              <BreadcrumbItem>
                <BreadcrumbPage className="tw:text-sm tw:font-medium tw:text-muted-foreground">
                  {currentPageLabel}
                </BreadcrumbPage>
              </BreadcrumbItem>
              {currentStepLabel ? (
                <>
                  <BreadcrumbSeparator className="tw:text-muted-foreground">
                    <ChevronRight />
                  </BreadcrumbSeparator>
                  <BreadcrumbItem>
                    <BreadcrumbPage className="tw:text-sm tw:font-semibold tw:text-foreground">
                      {currentStepLabel}
                    </BreadcrumbPage>
                  </BreadcrumbItem>
                </>
              ) : null}
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        <div className="tw:flex tw:items-center tw:gap-2">
          <UserMenu
            accountName="Blaze Ads"
            userName={user?.name ?? ""}
            userEmail={user?.email ?? ""}
            userInitials={getInitials(user?.name ?? "")}
            theme={theme}
            onThemeChange={onThemeChange}
            onLogout={onLogout}
            showBackoffice={realm === "staff"}
          />
        </div>
      </div>
    </header>
  );
}
